import { render, staticRenderFns } from "./AccountSummary.vue?vue&type=template&id=4fadde8c"
import script from "./AccountSummary.vue?vue&type=script&lang=js"
export * from "./AccountSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports